import { createBrowserRouter } from "react-router-dom";
import React from "react";

import Home from "../components/Home/Home";
import Index from "../components/Layout/Index";


import Login from "../components/Auth/Login";
import Register from "../components/Auth/Register";
import AdminIndex from "../components/Protected/AdminIndex";
import PageNotFound from "../components/PageNotFound/PageNotFound";
import About from "../components/About/About";
import Contact from "../components/Contact/Contact";
import ProductsPage from "../components/Products/ProductPage/ProductsPage";
import ProductInfo from "../components/Products/ProductPage/ProductInfo";
import Cart from "../components/Shop/Cart/Cart";
import RegisterCard from "../components/Shop/RegisterCard/RegisterCard";
import Success from "../components/Stripe/Success";
import Cancel from "../components/Stripe/Cancel";
import PrivacyPolicy from "../components/PrivacyPolicy/PrivacyPolicy";
import AddProducts from "../components/Protected/Products/AddProducts";
import EditProduct from "../components/Protected/Products/EditProduct";
import ViewProducts from "../components/Protected/Products/ViewProducts";
import Orders from "../components/Protected/Sales/Orders";
import FulfillOrder from "../components/Protected/Sales/FulFillOrder";

// Root route
export const ROOT = "/";

export const HOME = "/home";
export const ABOUT = "/about";
export const CONTACT = "/contact";
export const PRIVACY = "/privacy";


// Product Routes
export const PRODUCT = "/products/:id";
export const PRODUCTS = "/products";
export const CART = "/cart";
export const REGISTERCARD = "/register-card";
export const SUCCESS = "/success";
export const CANCEL = "/cancel";

// Auth Routes
export const LOGIN = "/auth/login";
export const REGISTER = "/auth/registerdfgf";

// Protected Routes
export const PROTECTED = "/protected";
export const ADD_PRODUCT = "add-product";
export const EDIT_PRODUCT = "edit/:id";
export const ADMIN_PRODUCTS = "products";
export const ADMIN_ORDERS = "orders";
export const ADMIN_ORDER_DETAIL = "orders/:id";



// Create Router
export const router = createBrowserRouter([
  {
    path: ROOT,
    element: <Index />,
    children: [
      {
        path: HOME,
        element: <Home />,
      },
      {
        path: PRIVACY,
        element: <PrivacyPolicy />,
      },
      {
        path: ABOUT,
        element: <About />,
      },
      {
        path: CONTACT,
        element: <Contact />,
      },
      {
        path: PRODUCTS,
        element: <ProductsPage />,
      },
      {
        path: PRODUCT,
        element: <ProductInfo />,
      },
      {
        path: CART,
        element: <Cart />,
      },
      {
        path: REGISTERCARD,
        element: <RegisterCard />
      },
      {
        path: "/success",
        element: <Success />,
      },
      {
        path: "/cancel",
        element: <Cancel />,
      },
    ],
  },
  {
    path: PROTECTED,
    element: <AdminIndex />,
    children: [
      {
        path: ADD_PRODUCT,
        element: <AddProducts />
      },  
      {
        path: "edit/:id",
        element: <EditProduct />
      },
      {
        path: ADMIN_PRODUCTS,
        element: <ViewProducts />
      },
      {
        path: ADMIN_ORDERS,
        element: <Orders />
      },
      {
      path: "orders/:id", // Add this child route
      element: <FulfillOrder /> // You'll need to create this component
    }
    ],
  },
  {
    path: LOGIN,
    element: <Login />,
  },
  {
    path: REGISTER,
    element: <Register />,
  },
  {
    path: "*",
    element: <PageNotFound />,
  },
]);

export default router;
